// extracted by mini-css-extract-plugin
export default {"track":"GrowthJourney_track__eXjCf","stage":"GrowthJourney_stage__G8uTK","head":"GrowthJourney_head__BjCC1","icon":"GrowthJourney_icon__l1we+","when":"GrowthJourney_when__+6DB1"};